/**
 * Creates a fingerprint object representing the current state
 * This is used to determine if the state has meaningfully changed
 * 
 * @param {Array} messages - The messages array
 * @param {Object} matchResults - The match results object
 * @param {Array} icpRequirements - The ICP requirements array
 * @returns {Object} A fingerprint object representing the current state
 */
export function createStateFingerprint(messages, matchResults, icpRequirements) {
  return {
    messagesLength: messages ? messages.length : 0,
    messagesLastId: messages && messages.length > 0 ? 
      (messages[messages.length - 1].id || `msg-${messages.length}`) : null,
    matchResultsId: matchResults ? 
      (matchResults.id || 
       (matchResults.search_gen_response && matchResults.search_gen_response.id) || 
       Date.now()) : null,
    icpRequirementsLength: icpRequirements ? icpRequirements.length : 0,
    icpRequirementsHash: icpRequirements ? 
      icpRequirements.reduce((hash, req) => hash + (req.section_name || '').length, 0) : 0
  };
}

/**
 * Compares two state fingerprints to determine if they are equal
 * 
 * @param {Object} fp1 - The first fingerprint
 * @param {Object} fp2 - The second fingerprint
 * @returns {boolean} True if the fingerprints are equal, false otherwise
 */
export function areStateFingerprintsEqual(fp1, fp2) {
  if (!fp1 || !fp2) return false;
  
  return fp1.messagesLength === fp2.messagesLength &&
         fp1.messagesLastId === fp2.messagesLastId &&
         fp1.matchResultsId === fp2.matchResultsId &&
         fp1.icpRequirementsLength === fp2.icpRequirementsLength &&
         fp1.icpRequirementsHash === fp2.icpRequirementsHash;
}
